<template>
  <div>
    <DefaultLink
      :to="getProductDetailRoute(product)"
      class="relative overflow-hidden rounded-md bg-gray-200"
    >
      <ProductImage
        v-if="image"
        :image="image"
        sizes="xs:100vw sm:100vw md:100vw"
        fit="cover"
        :image-loading="!index ? 'eager' : 'lazy'"
        class="h-44 w-32 p-1"
      />
      <ProductPromotionFreeGiftBadge
        :style="promotionStyle"
        class="absolute bottom-2 left-2"
      />
    </DefaultLink>
    <p
      class="text-2xs mt-1 overflow-hidden break-words font-medium uppercase text-secondary"
    >
      {{ brand }}
    </p>
    <Headline tag="h1" size="sm" class="mb-1 font-medium">
      {{ name }}
    </Headline>
  </div>
  <AppButton size="sm" class="mt-2" @click="toggleGiftSelection()">
    {{ toggleGiftSelectionLabel }}
  </AppButton>
  <template v-if="giftPromotion">
    <ProductPromotionSelectionModal
      v-if="isGreaterOrEquals('md')"
      v-bind="{ product, promotedProduct }"
      :promotion="giftPromotion"
    />
    <ProductPromotionSizeSelection
      v-else
      v-bind="{ product, promotedProduct }"
      :promotion="giftPromotion"
    />
  </template>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'

type Props = {
  product: Product
  basketItem: FimBasketItem
  index: number
}

const props = defineProps<Props>()

const i18n = useI18n()
const { getProductDetailRoute } = useRouteHelpers()

const { isGreaterOrEquals } = useViewport()

const promotedProduct = computed(() => props.basketItem.product)

const { toggleGiftSelection } = await usePromotionGiftSelection(
  props.product,
  promotedProduct.value,
)

const { giftPromotion, promotionStyle } = await useBasketItemPromotion(
  toRef(props.basketItem),
)

const toggleGiftSelectionLabel = computed(() => {
  return i18n.t('basket.promotion.add_free_gift')
})

const { image, brand, name } = useProductBaseInfo(props.product)
</script>
